import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { Maybe } from '@acme/core'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { Alteracao } from 'service/api'

interface IProps {
    value: Alteracao
}

const FIELD_OLD = '__old',
    FIELD_NEW = '__new'

type Diff = {
    [key: string]: {
        [FIELD_OLD]: string
        [FIELD_NEW]: string
    }
}
export default function TabDiff({ value }: IProps) {
    const diff: Diff =
        typeof value.diff === 'string' ? JSON.parse(value.diff) : value.diff

    const rows = Object.entries(diff).map(([key, value]) => ({
        id: key,
        [FIELD_OLD]: value[FIELD_OLD],
        [FIELD_NEW]: value[FIELD_NEW],
    }))

    const dadosBasicos = [
        {
            campo: 'Usuário responsável',
            valor: Maybe.from(
                (value as any)?.Usuario?.Supervisor?.nome,
            ).mapOrElse(
                nome => `${nome} (${value?.Usuario?.email})`,
                () => (value as any).Usuario?.email,
            ),
        },
        {
            id: 2,
            campo: 'Data da alteração',
            valor: dayjs(value.createdAt).format('DD/MM/YYYY HH:mm'),
        },
    ]

    const columns: GridColDefPro[] = [
        {
            field: 'id',
            headerName: 'Campo',
            width: 150,
            disableColumnMenu: true,
        },
        {
            field: FIELD_OLD,
            headerName: 'Antes',
            flex: 1,
            disableColumnMenu: true,
            cellClassName: 'bg-red-500 text-white hover:bg-red-700',
        },
        {
            field: FIELD_NEW,
            headerName: 'Depois',
            flex: 1,
            disableColumnMenu: true,
            cellClassName: 'bg-green-600 text-white hover:bg-green-800',
        },
    ]

    return (
        <>
            <div className="mb-4">
                {dadosBasicos.map((item, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-between [&>:first-child]:font-bold"
                    >
                        <span className="text-sm font-medium">
                            {item.campo}:
                        </span>
                        <span className="text-base">{item.valor}</span>
                    </div>
                ))}
            </div>
            <ContentGuide.DataGrid
                loading={false}
                columns={columns}
                rows={rows}
                ToolbarProps={{ hideToolbar: true }}
                hideFooter
                headerHeight={0}
                rowHeight={40}
            />
        </>
    )
}
